import React, { useEffect, useState } from 'react';
import { ArrowRight, ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
interface MobileBottomCTAProps {
  nextCaseStudySlug?: string;
  nextCaseStudyTitle?: string;
}
export function MobileBottomCTA({
  nextCaseStudySlug,
  nextCaseStudyTitle
}: MobileBottomCTAProps) {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 z-50 transform transition-transform duration-300 translate-y-0" data-id="element-373" data-mp="16doyqff7v19">
      <button onClick={() => {
      if (nextCaseStudySlug) {
        navigate(`/case-study/${nextCaseStudySlug}`);
        window.scrollTo(0, 0);
      } else {
        navigate('/');
        window.scrollTo(0, 0);
      }
    }} className={`w-full flex items-center ${nextCaseStudySlug ? 'justify-between' : 'justify-center gap-2'} bg-black text-white px-6 py-3.5 rounded-xl font-medium text-sm active:scale-[0.98] transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2`} data-id="element-374" data-mp="10qfq2oy4opu4">
        {nextCaseStudySlug ? <>
            <span data-id="element-375" data-mp="1anbzcwvupfzq">{`Next: ${nextCaseStudyTitle}`}</span>
            <ArrowRight className="w-4 h-4" data-id="element-376" data-mp="15q2b3kk77adh" />
          </> : <>
            <ArrowLeft className="w-4 h-4" data-id="element-377" data-mp="3vf4ecmrf8bav" />
            <span data-id="element-378" data-mp="3vfvyn1fkimlu">Back to home</span>
          </>}
      </button>
    </div>;
}